export default class Locale_ProjectListItem {
	ProjectType: string = "ProjectType";
}